import { Shield, Target, Award, Clock, Check } from "lucide-react";

const principles = [
  { icon: Shield, text: "Preparation before participation" },
  { icon: Target, text: "Structure before speed" },
  { icon: Award, text: "Responsibility over hype" },
  { icon: Clock, text: "Long-term capability over short-term outcomes" }
];

const ModernEcosystems = () => {
  return (
    <section data-testid="modern-ecosystems-section" className="section-dark">
      <div className="section-pattern"></div>
      <div className="section-glow center"></div>
      
      <div className="container narrow">
        <div className="section-header">
          <h2 className="section-title">Preparing for Modern Trading Ecosystems</h2>
          <div className="section-divider"></div>
        </div>
        
        <div className="feature-list">
          {principles.map((item, index) => (
            <div key={index} className="feature-item">
              <div className="feature-icon">
                <item.icon />
              </div>
              <p className="feature-text">{item.text}</p>
            </div>
          ))}
        </div>
        
        <p className="gold-statement" style={{ textAlign: 'center' }}>
          Tools can amplify decisions. <span className="gold">Education shapes decisions.</span>
        </p>
      </div>
    </section>
  );
};

export default ModernEcosystems;
